import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Template } from 'src/app/core/models/template-upload.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort} from '@angular/material/sort';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpErrorResponse } from '@angular/common/http';
import { UploadTemplatePopupComponent } from './components/upload-template-popup/upload-template-popup.component';
import { NotePopupComponent } from './components/note-popup/note-popup.component';
import { TemplateUploadService } from 'src/app/core/services/template-upload.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { GetTemplateList } from 'src/app/core/store/template-upload.action';
import { Plant } from 'src/app/core/models/plants.model';
import { ConstantsUtil } from 'src/app/core/utils/constants.util';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { ThemeSwitchService } from 'src/app/core/services/theme/theme-switch.service';
import { Theme } from 'src/app/core/models/Theme.enum';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator, {static : true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  public uploadTemplateModalRef: BsModalRef;
  public noteModalRef: BsModalRef;
  public dataSource = new MatTableDataSource();
  public displayedColumns: string[] = ['AssetType','PlantName', 'Version', 'CreatedByUserName','CreatedOn','UpdatedByUserName','UpdatedOn'];
  
  public limit = 10;
  public isLoading = false;
  public templateList: Template[] = [];
  public showError: boolean = false;
  public downloadErrorMessage: string = '';
  public unsubscribe = new Subject<void>();
  public plantList: Plant[] =  [];
  public childList: string[] =  [];
  public completeAssetsList:Plant[] = [];
  public completeChildList: string[] =  [];
  public showParentDropdown: boolean = false;
  public showChildDropdown: boolean = false;
  public selectedPlant: Plant;
  public selectedChild : string = '';
  public isDisable: boolean = true;
  public pathArr: string[] = [];
  public folderName: string;
  public isDisableButton: boolean = false;
  constructor(
    public modalService: BsModalService, 
    public templateUploadService: TemplateUploadService,
    public store: Store,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private themeSwitchService: ThemeSwitchService
    ) { }

  public ngOnInit(): void {
    this.route.data.subscribe((data: Data)=>{
      if(data['usersByToken']['Users'][0].UserRoles.findIndex((ur)=>{
        return ur.RoleName === ConstantsUtil.roles.ADMIN_OH;
      }) == -1){
        this.router.navigateByUrl(ConstantsUtil.routes.SLASH_ADMIN_ERROR)
      }
    })
    this.isLoading = true;
    this.getPlantList();
    this.isDisableButton = true;
  }

  public ngAfterViewInit(): void {
    this.getUpdatedList();
  }

  public getTemplateList(plantName, assetType,plantId): void {
  
    this.store.dispatch(new GetTemplateList(plantName, assetType,plantId))
    .subscribe((state) => {
      this.isLoading = false;
     
       this.templateList  = state.template.templateList;
      this.pathArr = [];
        if(this.templateList.length != 0){
          this.templateList.forEach((item) => {
            this.pathArr.push(item.FilePath);
          })
          } else {
            this.pathArr = [];
        }
      this.folderName = this.selectedChild ? ConstantsUtil.prefixes.ENTITYVIEWER_UNDERSCORE + this.selectedPlant?.PlantName + ConstantsUtil.prefixes.UNDERSCORE + this.selectedChild : ConstantsUtil.prefixes.ENTITYVIEWER_UNDERSCORE + this.selectedPlant?.PlantName;
      this.dataSource = new MatTableDataSource(this.templateList);
      this.isDisableButton = false;
      this.changeDetectorRef.detectChanges();
      if(this.dataSource.data.length) {
        this.dataSource.sort = this.sort;
        this.dataSource.sort.disableClear = true;

        this.dataSource.paginator = this.paginator;
        this.paginator._intl.nextPageLabel ='';
        this.paginator._intl.previousPageLabel ='';
        this.paginator._intl.firstPageLabel = '';
        this.paginator._intl.lastPageLabel = '';
      }
    })
  }

  public getUpdatedList(): void {
    this.templateUploadService.uploadDetail$.pipe(takeUntil(this.unsubscribe))
    .subscribe(data => {
        this.isLoading = true;
        this.isDisableButton = true;
        this.getTemplateList(this.selectedPlant?.PlantName,this.selectedChild,this.selectedPlant?.PlantId);
  
    })
  }

  public onUploadTemplateClicked(): void {
   if(this.selectedChild === '' || this.selectedChild === null){
    this.noteModalRef = this.modalService.show(NotePopupComponent, {
      class: 'modal-lg modal-dialog-centered modal-message',
    })
   } else {
    this.uploadTemplateModalRef = this.modalService.show(UploadTemplatePopupComponent, {
      class: 'modal-md modal-dialog-centered',
      backdrop: 'static',
      animated: true,
      initialState: {
        assetType : this.selectedChild,
        plant: this.selectedPlant.PlantName,
        plantId: this.selectedPlant.PlantId,
        folderName : ConstantsUtil.prefixes.ENTITYVIEWER_UNDERSCORE + this.selectedPlant?.PlantName + '_'+ this.selectedChild 
     },
    })
   }
  }

  public downloadExcel(): void{
    this.isDisableButton = true;
    this.templateUploadService.downloadFile(this.pathArr, this.folderName).pipe(takeUntil(this.unsubscribe)).subscribe({next: (res)=>{
      let blob = new Blob([res.body], {type: "application/vnd.ms-excel.sheet.macroEnabled.12"});
      const filename = res.headers.get('content-disposition').split(';')[1].split('=')[1].replace(/"/g, '')
      let url = window.URL.createObjectURL(blob);
      let anchor = document.createElement("a");
      anchor.download = filename;
      anchor.href = url;
      anchor.click();
      this.isDisableButton = false;
    }, error: (error: HttpErrorResponse)=>{
      if(error.status === 400)
      {
        this.showError = true;
        this.isDisableButton = false;
        error.error.text().then((errorMessage)=>{
          this.downloadErrorMessage = errorMessage;
        })
      }
    }});
  }
  
  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public getPlantList(): void {
  	this.templateUploadService.getPlantsList().subscribe((response) => {
			this.plantList=[];
			this.completeAssetsList=[];
			response.plantlist.sort((a, b) => a.PlantName.toLowerCase() > b.PlantName.toLowerCase() ? 1 : -1).forEach((i)=>
			{
				this.completeAssetsList.push(i);
			})
      this.completeAssetsList.unshift( {
				"PlantId" : "Multi-Plant",
				"PlantName" : "Multi-Plant",
			  }
			);
			this.plantList = this.completeAssetsList;
      this.selectedPlant = this.plantList[0];
      this.getChildList(this.selectedPlant?.PlantId);
		})
  }

  public getChildList(plantId : string): void {
    this.templateUploadService.getChildList(plantId).subscribe((response) => {
      this.childList=[];
      this.completeChildList=[]; 
      response.AssetTypes.sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1).forEach((i)=>
			{
				this.completeChildList.push(i);
			});
      this.childList = this.completeChildList;
      this.selectedChild = null;
      this.isDisableButton = true;
      this.getTemplateList(this.selectedPlant.PlantName,this.selectedChild,this.selectedPlant.PlantId);
      this.isDisable = false;
    })
  }
  
    public toggleParentDropdown(): void {
      this.showParentDropdown = !this.showParentDropdown;
      this.showChildDropdown = false;
    }
  
    public toggleChildDropdown(): void {
      this.showParentDropdown = false;
      this.showChildDropdown = !this.showChildDropdown;
    }
  
    public selectPlant(plant): void {
      if((this.selectedPlant.PlantName === plant.PlantName && this.selectedChild !== null) || this.selectedPlant.PlantName !== plant.PlantName) {
        this.selectedPlant = plant;
        this.selectedChild = null;
        this.showParentDropdown = false;
        this.isDisable = true;
        this.isLoading = true;
        this.getChildList(plant.PlantId);
       }
    }
  
    public selectChild(child): void {
      if(this.selectedChild !== child) {
        this.selectedChild = child;
        this.showChildDropdown = false;
        this.isLoading = true;
        this.isDisableButton = true;
        this.getTemplateList(this.selectedPlant.PlantName,this.selectedChild,this.selectedPlant.PlantId);
     
      }
    }

    public onClickedOutsidePlant(): void {
      this.showParentDropdown = false;
    }

    public onClickedOutsideChild(): void {
      this.showChildDropdown = false;
    }

    /**
     * get upload image
     */
    public get uploadImage(){
      return this.themeSwitchService.getTheme() === Theme.DARK ? 'upload-icon.svg' : 'upload-icon-light-theme.svg';
    }

    /**
     * get download image
     */

   public get downloadImage(): string {
       const isDark = this.themeSwitchService.getTheme() === Theme.DARK;
         if (this.isDisableButton) {
          return isDark ? 'download-icon-disabled.svg' : 'download-icon-disabled-light-theme.svg';
        } else {
          return isDark ? 'download-icon.svg' : 'download-icon-light-theme.svg';
    }
   }
    

    /**
     * get expand image
     */
    public get expandImage(){
      return this.themeSwitchService.getTheme() === Theme.DARK ? 'Expand.svg' : 'Expand-light-theme.svg';
    }

    /**
     * get selected option background color
     */
    public get selectedOptionBGColor(){
      return this.themeSwitchService.getTheme() === Theme.DARK ? getComputedStyle(document.documentElement).getPropertyValue('--accentColorAC03'.trim()) : getComputedStyle(document.documentElement).getPropertyValue('--accentColorAC03-light-theme'.trim())
    }

    /**
     * get error image
     */
    public get errorImage(){
      return this.themeSwitchService.getTheme() === Theme.DARK ? 'error.svg' : 'error-light-theme.svg';
    }
}
